import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "auth-state"

  connect() {
    super.connect()
    const authenticated = this.bridgeElement.bridgeAttribute("authenticated") === "true"
    this.send("update", { authenticated }, () => {})
  }
}
